<lcs-loading-overlay
   class="flex-dir-col"
   [show]="callState | lcsCallState : 'loading'"
   *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Account'"
>
   <div class="detail-page-headerbar">
      <div class="left">
         <div class="page-heading">
            @if (account?.accountId && idsFromRegister?.length > 0) {
            <div class="nav-buttons">
               <button [disabled]="!hasNavigateUp" mat-icon-button (click)="onNavigateUp()">
                  <mat-icon>keyboard_arrow_left</mat-icon>
               </button>
               <span class="detail-index">{{ indexDisplay }}</span>
               <button [disabled]="!hasNavigateDown" mat-icon-button (click)="onNavigateDown()">
                  <mat-icon>keyboard_arrow_right</mat-icon>
               </button>
            </div>
            }
            <h2 class="page-title">Account Settings</h2>
         </div>
      </div>
      <div class="right context-actions">
         @if (account?.isInternationalDialingSuspended) {
         <button mat-button color="warn" (click)="onActivateClick(isSystemUser)">
            <mat-icon>warning</mat-icon>
            <span class="dialing-disabled-indicator">International Dialing Disabled</span>
         </button>
         }
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="updateDetailsMenu"
            matTooltip="Info"
            aria-label="Account Info"
            id="account-detail-info"
         >
            <mat-icon>info</mat-icon>
         </button>
         @if (this.extensionPrivileges.canAddPhones) {
         <div>
            <button
               type="button"
               mat-button
               [matMenuTriggerFor]="accountMenu"
               aria-label="Account Actions"
               matTooltip="More Actions"
               id="account-detail-more-actions"
            >
               <mat-icon>more_horiz</mat-icon>
            </button>
         </div>
         }
      </div>
   </div>
   <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
         <div ndtLeftColumn>
            <div class="details-wrapper">
               @if (account?.shortName) {
               <h5>Company Code</h5>
               <div class="detail-item company-code-text">{{ account.shortName }}</div>
               } @if (account?.shortName && sipDomain) {
               <h5>Domain</h5>
               <div class="detail-item domain-text">{{ account.shortName + sipDomain }}</div>
               } @if (account?.lcsAccountNumber) {
               <h5>LCS Account #</h5>
               <div class="detail-item">{{ account.lcsAccountNumber }}</div>
               }
               <ng-container>
                  <h5>Active Dates</h5>
                  <div class="detail-item"
                     >{{ account?.activeStartDate ? (account?.activeStartDate | date : 'MM/dd/yyyy') : 'Inactive' }}
                     -
                     {{
                        account?.activeStartDate
                           ? account?.activeEndDate
                              ? (account?.activeEndDate | date : 'MM/dd/yyyy')
                              : 'Current'
                           : ''
                     }}
                     @if (isSystemUser && accountPrivileges.canEdit) {
                     <a class="change-active-date-link" (click)="onActiveDateChangeClick()">(Change)</a>
                     }
                  </div> </ng-container
               ><ng-container>
                  <h5>External Integration</h5>
                  <div class="detail-item"
                     >{{ account?.presenceEnabled ? 'Enabled' : 'Disabled' }}

                     @if (accountPrivileges.canEdit && account?.presenceEnabled && isSystemUser) {
                     <a class="change-active-date-link" (click)="onEditPresenceCredentialsClick()">(Configure)</a>
                     }
                  </div>
                  @if (form.get('presenceEnabled')?.value && !account?.hasPresenceCredentials && isSystemUser) {
                  <div class="detail-item alert-text"> Please complete setup. </div>
                  }
               </ng-container>
               <ng-container>
                  <h5>Account Type</h5>
                  <div class="detail-item">
                     {{ account?.isResidential ? 'Residential' : 'Business' }}
                     {{ account?.isLcsInternal ? ' - Internal' : '' }}
                  </div>
                  <div class="detail-item alert-text"> {{ account?.isSuspended ? 'Suspended' : '' }}</div>
               </ng-container>
               @if (account?.logLevelChanged && isSystemUser) {
               <h5>Log Level Changed</h5>

               <div class="detail-item">
                  Changed:
                  {{ account?.logLevelChanged | date : 'MM/dd/yyyy' : 'UTC' }}
               </div>

               <div class="detail-item">
                  By:
                  {{ account?.logLevelChangedByUser?.username || 'Unknown' }}
               </div>

               <div class="detail-item">
                  Reason:
                  {{ account.reasonLogLevelChanged || 'Unknown' }}
               </div>
               }
            </div>
         </div>
         <div ndtRightColumn>
            <div class="detail-right-column">
               <ndt-card [title]="'Account Information'" class="detail-card-half">
                  <mat-form-field class="flex-half">
                     <mat-label>Name</mat-label>
                     <input
                        matInput
                        autocomplete="off"
                        type="text"
                        [value]="account?.name"
                        formControlName="name"
                        required
                     />
                     @if (form.get('name')?.hasError('required')) {
                     <mat-error> Name is Required. </mat-error>
                     } @if (form.get('name')?.hasError('pattern') || form.get('name')?.hasError('noContent')) {
                     <mat-error> Name must contain characters. </mat-error>
                     }
                  </mat-form-field>
                  <mat-form-field class="flex-half">
                     <mat-label>LCS Account #</mat-label>
                     <input
                        matInput
                        autocomplete="off"
                        type="text"
                        [value]="account?.lcsAccountNumber"
                        formControlName="lcsAccountNumber"
                     />
                     @if (form.get('lcsAccountNumber')?.hasError('pattern')) {
                     <mat-error>Must be a number</mat-error>
                     } @if (form.get('lcsAccountNumber')?.hasError('max')) {
                     <mat-error>Must be less than 11 digits</mat-error>
                     }
                  </mat-form-field>
                  <mat-form-field class="flex-half">
                     <mat-label>Line Limit</mat-label>
                     <input
                        matInput
                        autocomplete="off"
                        type="number"
                        [value]="account?.pstnLineLimit"
                        formControlName="pstnLineLimit"
                        required
                     />
                     @if (form.get('pstnLineLimit')?.hasError('required')) {
                     <mat-error> Line Limit is Required. </mat-error>
                     } @if (form.get('pstnLineLimit').hasError('min')) {
                     <mat-error> Line Limit must be greater than 0 </mat-error>
                     } @if (form.get('pstnLineLimit').hasError('pattern')) {
                     <mat-error> Line Limit must be an integer </mat-error>
                     } @if (form.get('pstnLineLimit').hasError('max')) {
                     <mat-error> Line Limit must be less than 1000 </mat-error>
                     }
                  </mat-form-field>
                  @if (isSystemUser) {
                  <mat-form-field class="flex-full">
                     <mat-label>Admin Notes</mat-label>
                     <textarea
                        matInput
                        autocomplete="off"
                        [value]="account?.note?.notes"
                        formControlName="note"
                        id="account-admin-note"
                     ></textarea>
                  </mat-form-field>
                  }
               </ndt-card>
               <ndt-card [title]="'Account Features'" class="detail-card-half">
                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isInternationalDialingEnabled"
                     formControlName="isInternationalDialingEnabled"
                     >International Dialing</mat-checkbox
                  >
                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isMailboxMessageTranscriptionEnabled"
                     formControlName="isMailboxMessageTranscriptionEnabled"
                     id="d298eb08-d454-43e6-8b58-46ef700d8d97"
                     >Voicemail Transcription</mat-checkbox
                  >

                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.presenceEnabled"
                     formControlName="presenceEnabled"
                     id="presenceEnabled"
                     >External Integration</mat-checkbox
                  >
                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isFmFmEnabled"
                     formControlName="isFmFmEnabled"
                     id="5ebe9694-2f8c-4a58-abf8-acddf82096f0"
                     >Enable Find Me/Follow Me</mat-checkbox
                  >
                  <mat-checkbox
                     class="flex-full"
                     formControlName="outboundRecordingNotificationEnabled"
                     [checked]="account?.outboundRecordingNotificationEnabled"
                     id="outboundRecordingNotificationEnabled"
                  >
                     Enable Outbound Call Recording Notification
                  </mat-checkbox>
               </ndt-card>
               <ndt-card [title]="'Account Defaults'" class="detail-card">
                  <mat-form-field class="flex-half">
                     <mat-label>Time Zone</mat-label>
                     <input
                        [lcsSingleSelect]="timeZoneSelect"
                        ndtTimeZoneSelect
                        autocomplete="off"
                        type="text"
                        formControlName="timeZoneId"
                        id="time-zone"
                        required
                     />
                     <ndt-time-zone-select #timeZoneSelect></ndt-time-zone-select>
                     @if (form.get('timeZoneId')?.hasError('required')) {
                     <mat-error> Time Zone Field is Required. </mat-error>
                     }
                  </mat-form-field>
                  <mat-form-field class="flex-half">
                     <mat-label>Default Area Code</mat-label>
                     <input
                        matInput
                        autocomplete="off"
                        type="number"
                        [value]="account?.defaultAreaCode"
                        formControlName="defaultAreaCode"
                     />
                     @if ( form.get('defaultAreaCode')?.hasError('invalidAreaCode') ||
                     form.get('defaultAreaCode')?.hasError('numeric') ||
                     form.get('defaultAreaCode')?.hasError('specialcharacters') ||
                     form.get('defaultAreaCode')?.hasError('max') ) {
                     <mat-error> Please enter a valid area code. </mat-error>
                     }
                  </mat-form-field>
                  <mat-form-field class="flex-half">
                     <mat-label>Name Directory Search Preference</mat-label>
                     <input
                        ndtNameDirectoryPreferenceSelect
                        [lcsSingleSelect]="nameDirectoryPreferenceSelect"
                        autocomplete="off"
                        type="text"
                        formControlName="nameDirectoryPreferenceId"
                        id="nameDirectoryPreferenceId"
                        required
                     />
                     <ndt-name-directory-preference-select
                        #nameDirectoryPreferenceSelect
                     ></ndt-name-directory-preference-select>
                     @if (form.get('callRetentionPolicyTypeId').hasError('required')) {
                     <mat-error> Name Directory Search Preference is required </mat-error>
                     }
                  </mat-form-field>
                  @if (account?.accountId) {
                  <mat-form-field class="flex-half">
                     <mat-label>Operator Extension*</mat-label>
                     <input
                        [lcsSingleSelect]="extensionSelect"
                        [accountId]="account?.accountId"
                        ndtExtensionSelect
                        autocomplete="off"
                        type="text"
                        formControlName="operatorExtension"
                        id="operatorExtension"
                        [extensionTypesToExclude]="[6, 7]"
                     />
                     <ndt-extension-select #extensionSelect></ndt-extension-select>
                     @if (form.get('operatorExtension')?.hasError('required')) {
                     <mat-error> Operator Extension Field is Required. </mat-error>
                     }
                  </mat-form-field>
                  } @if (account?.accountId) {
                  <mat-form-field class="flex-half">
                     <mat-label>Fax File Type</mat-label>
                     <input
                        [lcsSingleSelect]="faxFileTypeSelect"
                        ndtFaxFileTypeSelect
                        autocomplete="off"
                        type="text"
                        formControlName="faxFileTypeId"
                        id="faxFileTypeId"
                        required
                     />
                     <ndt-fax-file-type-select #faxFileTypeSelect></ndt-fax-file-type-select>
                     @if (form.get('faxFileTypeId')?.hasError('required')) {
                     <mat-error> Fax File Type is Required. </mat-error>
                     }
                  </mat-form-field>
                  } @if (account?.accountId) {
                  <mat-form-field class="flex-half">
                     <mat-label>Schedule</mat-label>
                     <input
                        autocomplete="off"
                        type="text"
                        [lcsSingleSelect]="scheduleSelect"
                        ndtScheduleSelect
                        [accountId]="account?.accountId"
                        formControlName="schedule"
                        id="schedule"
                     />
                     <ndt-schedule-select #scheduleSelect isIncludeEmptyOption="true"></ndt-schedule-select>
                  </mat-form-field>
                  } @if (account?.accountId && (isAdminUser||isSystemUser)) {
                  <div class="flex-container flex-full">
                     <mat-form-field class="flex-half">
                        <mat-label>Queue Management Strategy</mat-label>

                        <input
                           autocomplete="off"
                           type="text"
                           [lcsSingleSelect]="queueManagementStrategySelect"
                           ndtQueueManagementStrategySelect
                           formControlName="queueManagementStrategyTypeId"
                           id="queueManagementStrategyTypeId"
                           required
                        />

                        <ndt-queue-management-strategy-select
                           #queueManagementStrategySelect
                           (optionSelected)="onQueueStrategyOptionSelected($event)"
                           >> </ndt-queue-management-strategy-select
                        >@if (form.get('queueManagementStrategyTypeId')?.hasError('required')) {
                        <mat-error> Queue Management Strategy is Required. </mat-error>
                        }
                     </mat-form-field>
                     @if (isManagedQueueStrategy) {
                     <mat-checkbox
                        class="flex-half"
                        [checked]="account?.isAgentCanAssign"
                        formControlName="isAgentCanAssign"
                        id="isAgentCanAssign"
                        >Agents Can Assign Queues</mat-checkbox
                     >
                     }
                  </div>
                  }
                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isMissedCallsShown"
                     formControlName="isMissedCallsShown"
                     id="b97f46ab-a5ff-48c5-8e2c-d5322c3f7e10"
                     >Show Missed Calls on Provisioned Phones</mat-checkbox
                  >
               </ndt-card>
               <ndt-card [title]="'Hold Music'" class="detail-card-half">
                  <mat-checkbox
                     header-action
                     class="card-header-checkbox mat-contrast"
                     [checked]="holdMusicOptionValue === 'default'"
                     [disabled]="!accountPrivileges.canEdit"
                     id="isCustomHoldMusic"
                     (change)="onHoldMusicOptionChange($event)"
                     >Use System Default</mat-checkbox
                  >
                  <div class="flex-container hold-music">
                     @if (account?.accountId) {
                     <div class="flex-container prompt">
                        <mat-form-field class="flex-half with-half-button">
                           <mat-label>Hold Music Prompt</mat-label>
                           <input
                              [lcsSingleSelect]="mohPromptSelect"
                              [accountId]="account?.accountId"
                              [promptTypesToInclude]="[3]"
                              ndtPromptSelect
                              type="text"
                              formControlName="holdMusicPrompt"
                              id="holdMusicPrompt"
                              required
                           />
                           <ndt-prompt-select
                              #mohPromptSelect
                              [isIncludeEmptyOption]="false"
                              [promptIdsToInclude]="promptsToInclude"
                           ></ndt-prompt-select>
                           @if (form.get('holdMusicPrompt').hasError('required')) {
                           <mat-error> Hold Music Prompt is required </mat-error>
                           }
                        </mat-form-field>
                        <div class="flex-half-button">
                           @if (!form.disabled) {
                           <button
                              mat-mini-fab
                              [disabled]="!accountPrivileges.canEdit"
                              color="primary"
                              type="button"
                              (click)="dispatchUploadMohFile()"
                              class="prompt-button"
                           >
                              <mat-icon>add</mat-icon>
                           </button>
                           }
                        </div>
                     </div>
                     }
                  </div>
               </ndt-card>
               <ndt-card [title]="'Call Recording'" class="detail-card-half">
                  @if (account?.accountId && isSystemUser) {
                  <mat-checkbox
                     header-action
                     class="card-header-checkbox mat-contrast"
                     formControlName="isCallRecordingFeatureEnabled"
                  >
                     Enable
                  </mat-checkbox>
                  } @if (!isSystemUser && !form.get('isCallRecordingFeatureEnabled').value) {
                  <mat-icon
                     class="tooltip"
                     header-action
                     [appTooltip]="
                        'Call recording is not enabled on your account.\nPlease contact your LCS representative to enable this feature.'
                     "
                     >help</mat-icon
                  >
                  } @if (isSystemUser) {
                  <mat-form-field class="flex-half">
                     <mat-label>Recording Retention Policy</mat-label>
                     <input
                        ndtCallRetentionPolicySelect
                        [lcsSingleSelect]="callRetentionPolicySelect"
                        autocomplete="off"
                        type="text"
                        formControlName="callRetentionPolicyTypeId"
                        id="callRetentionPolicyTypeId"
                        required
                     />
                     <ndt-call-retention-policy-select
                        #callRetentionPolicySelect
                        [excludedValues]="'NegativeOne'"
                     ></ndt-call-retention-policy-select>
                     @if (form.get('callRetentionPolicyTypeId').hasError('required')) {
                     <mat-error> Retention Policy is required </mat-error>
                     }
                  </mat-form-field>
                  } @else { @if (form) {
                  <div class="retention-row">
                     <div class="retention-header">
                        <span class="retention-label">Recording Retention Policy</span>
                        <mat-icon
                           class="tooltip"
                           [appTooltip]="'To change your retention policy,\nplease contact your LCS representative.'"
                           >help</mat-icon
                        >
                     </div>
                     <div class="retention-value">
                        {{
                           form?.get('callRetentionPolicyTypeId')?.value?.callRetentionPolicy
                              | callRetentionPolicyFormat
                        }}
                     </div>
                  </div>
                  } }
                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isRecordInboundCalls"
                     formControlName="isRecordInboundCalls"
                     id="d298eb08-d454-43e6-8b58-46ef700d8d55"
                     >Inbound Calls</mat-checkbox
                  >
                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isRecordOutboundCalls"
                     formControlName="isRecordOutboundCalls"
                     id="cbc2a60a-fecd-49c8-a808-78d965600029"
                     >Outbound Calls</mat-checkbox
                  >
                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isRecordInternalCalls"
                     formControlName="isRecordInternalCalls"
                     id="820bfddd-97f2-4f42-9a92-53b55779e695"
                     >Extension to Extension (Internal Calls)</mat-checkbox
                  >

                  <mat-checkbox
                     class="flex-full"
                     [checked]="account?.isOtrEnabled"
                     formControlName="isOtrEnabled"
                     [disabled]="!form.get('isCallRecordingFeatureEnabled')?.value"
                     id="isOtrEnabled"
                     >Enable One-Touch Recording</mat-checkbox
                  >
               </ndt-card>
            </div>
         </div>
      </ndt-two-column-layout>
      <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
   </form>
</lcs-loading-overlay>
<mat-menu #updateDetailsMenu="matMenu">
   <update-details
      [createUser]="account?.createUser"
      [createDate]="account?.createDate"
      [updateUser]="account?.updateUser"
      [updateDate]="account?.updateDate"
   ></update-details>
</mat-menu>
<mat-menu #accountMenu="matMenu">
   @if (isSystemUser) {
   <button mat-menu-item type="button" (click)="onBulkConfigureClick()" id="bulk-configure-devices">
      Bulk Configure Phones
   </button>
   } @if (isSystemUser && accountPrivileges?.canRebootPhones) {
   <button mat-menu-item type="button" (click)="onRebootAllPhonesClick()" id="reboot-all-phones">
      Reboot All Phones
   </button>
   }
   <button (click)="onResetMwiClick()" mat-menu-item type="button" id="menu-extension-reset-mwi">
      Reset All MWIs
   </button>
   @if (account?.isInternationalDialingSuspended && isSystemUser) {
   <button type="button" mat-menu-item (click)="onActivateClick(isSystemUser)">Activate International Dialing</button>
   } @if (isSystemUser && hasLogLevelPrivilege) {
   <button mat-menu-item type="button" (click)="onChangeLogLevelClick()" id="log-level-option">Change Log Level</button>
   } @if (isSystemUser) {
   <button mat-menu-item type="button" (click)="onAdvancedOptionsClick()" id="advanced-options">Advanced</button>
   }
</mat-menu>
